import { createAction, props } from '@ngrx/store';
import { EstruturaRetornoDadosOutputDto } from 'src/app/domain/DTOs/output/estrutura-retorno-dados.output.dto';
import { ObterUltimaEdicaoECalendarioOutputDto } from 'src/app/domain/DTOs/output/jornal/ultima-edicao-e-calendario-para-home-output.dto';

const actionName = "[ ObterCalendarioHome ] Obter Jornais e Calendario Home";

export const obterUltimaEdicaoECalendario = createAction(
  actionName
);

export const obterUltimaEdicaoECalendarioSuccess = createAction(
  `${actionName} - Sucesso`,
  props<{ response: EstruturaRetornoDadosOutputDto<ObterUltimaEdicaoECalendarioOutputDto> }>()
);

export const obterUltimaEdicaoECalendarioFinish = createAction(
  `${actionName} - Concluir`
);
